export const isElementsStrategyName = (strategy) =>
  String(strategy || "").toLowerCase().includes("elements");

export const ELEMENTS_INITIAL_FEE_STAGE_HEADING =
  "Initial Stage Fees - Elements";

export const getElementsPathStrategyDisplayName = (pathStrategy) => {
  const name = String(pathStrategy || "").trim();
  const prefix = "Vicus Capital / Capital Group Strategies - ";
  return name.startsWith(prefix) ? name.slice(prefix.length).trim() : name;
};

export const getElementsPathFeeStageHeading = (pathStrategy) => {
  const displayName = getElementsPathStrategyDisplayName(pathStrategy);
  return displayName
    ? `Path Strategy Fees - ${displayName}`
    : "Path Strategy Fees";
};

// Every Elements program, including both Social Impact variants, carries its
// configured Elements/Path fee schedule. Keep this helper for old callers so
// restored records follow the same rule without a separate legacy branch.
export const shouldSuppressElementsPathStrategy = () => false;
